<!-------------- Confirmación ----------------->
<!--------------------------------------------->


<div class="container content">
    <div class="row">
        <div class="col-md-12">
            <h5 class="title-step" align="center">
                <img src="./assets/img/credit-card.svg" class="img-fluid ico-title" width="20"> Confirmación del contrato
            </h5>

            <!-- Notificación -->
            <div class="alert alert-success" role="alert" *ngIf="!activationError">
                <h4 class="alert-heading mt-2">
                    <div class="checkmark-white"></div> 
                    <b>Alta activada</b>
                </h4>
                <p>El alta de los servicios se ha realizado correctamente</p>
            </div>

            <div class="alert alert-danger" role="alert" *ngIf="activationError">
                <h4 class="alert-heading mt-2"> 
                    <b>Error</b>
                </h4>
                <ng-template [ngIf]="error && error.error && error.error.error && error.error.error.msg" [ngIfElse]="genericError">
                    <p>{{ error.error.error.msg }}</p>
                </ng-template>
                <ng-template #genericError>
                    <p>Ha ocurrido un error durante la activación</p>
                </ng-template>                
            </div>
        </div>
    </div>
</div>

<!-------------- ./ Confirmación ----------------->
<!------------------------------------------------>
<ng-container *ngIf="activationError">
    <div class="container content">
        <div class="row">
            <div class="col-md-12">
                <span (click)="retryActivation()" class="btn btn-black-outline btn-block mb-5">
                    <b>Reintentar</b>
                </span>
            </div>
        </div>
    </div>
</ng-container>

<app-cliente></app-cliente>
<app-resumen [ariaExpanded]="ariaExpanded" [showCollapse]="showCollapse"></app-resumen>

<!--------- Documentación para firmar ------------>
<!------------------------------------------------>
<ng-container *ngIf="!activationError">
    <div class="container firma mt-4 mb-5">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 class="subtitulo-pack2 ms-3">
                                            <b>Firma de contratos</b>
                                        </h6>
                                    </div>
                                    <small class="text-muted">
                                        <div class="checkmark-disabled"></div>
                                    </small>
                                </div>
                            </div>
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item cuerpo-pack-2">
                                    <h5 align="left" class="tar-name-7 mt-2 ms-3">
                                        Hay <b>2 documentos pendientes</b>
                                    </h5>
                                    <div class="d-flex">
                                        <h5 align="left" class="tar-name-8 mt-1 ms-3">
                                            <img src="./assets/img/file.svg" class="img-fluid ico-title" width="13"> Documento 1
                                        </h5>
                                    </div>

                                    <div class="d-flex">
                                        <h5 align="left" class="tar-name-8 mt-1 ms-3">
                                            <img src="./assets/img/file.svg" class="img-fluid ico-title" width="13"> Documento 2
                                        </h5>
                                    </div>
                                    <!--
                                    <div align="center" class="mt-5 mb-2">
                                        <a href="#!" data-toggle="modal" data-target="#contratos"
                                        class="btn btn-green btn-sm btn-block">Firmar documentos</a>
                                    </div>
                                    -->
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

  <!--------- MODALES DOCUMETACIÓN / CONTRATOS --------->
  <!---------------------------------------------------->


  <!-- Modal Documentación -->
  <!------------------------->

    <div class="modal fade" id="documentacion" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title white" id="exampleModalLabel">Documentación</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">
                            <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
                        </span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <!-- IBAN -->
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 class="subtitulo-pack4">IBAN</h6>
                                    <h6>
                                        <span class="badge badge-pill badge-success">Completado</span>
                                    </h6>
                                </div>

                                <small class="text-muted">
                                    <h6 class="subtitulo-pack3">scan-iban.pdf</h6>
                                    <div align="right">
                                        <a href=""><img src="./assets/img/eye.svg" class="img-fluid icon-nav2" width="17"></a>
                                        <a href=""><img src="./assets/img/trash.svg" class="img-fluid icon-nav2" width="17"></a>
                                    </div>
                                </small>
                            </div>

                            <div class="bb-line"></div>
                            <br>

                            <!-- RECIBOS -->
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 class="subtitulo-pack4">Recibo de autónomos</h6>
                                    <h6>
                                        <span class="badge badge-pill badge-success">Completado</span>
                                    </h6>
                                </div>

                                <small class="text-muted">
                                    <h6 class="subtitulo-pack3">recibo-enero.pdf</h6>
                                    <div align="right">
                                        <a href=""><img src="./assets/img/eye.svg" class="img-fluid icon-nav2" width="17"></a>
                                        <a href=""><img src="./assets/img/trash.svg" class="img-fluid icon-nav2" width="17"></a>
                                    </div>
                                </small>
                            </div>

                            <div class="bb-line"></div>
                            <br>

                            <!-- DNI -->
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 class="subtitulo-pack4">DNI del administrador</h6>
                                    <h6>
                                        <span class="badge badge-pill badge-pending">Pendiente</span>
                                    </h6>
                                </div>
                            </div>

                            <div class="area mb-4">
                                <div id="dropZone">
                                    <img src="./assets/img/upload-cloud.svg" class="img-fluid" width="35">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- ./ Modal  Documentación ----->
    <!-------------------------------->


    <!-- Modal Contratos ------>
    <!-------------------------->

    <div class="modal fade" id="contratos" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title white" id="exampleModalLabel">Firma de contratos</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20"></span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <h6 class="subtitulo-pack4">Listado de contratos</h6>

                            <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                                <div class="btn-group me-2" role="group" aria-label="">
                                    <div class="jumbotron-doc success-doc">
                                        <h6 class="subtitulo-pack3">
                                            <b>Documento aceptación GDPR</b>
                                        </h6>
                                        <h6 class="subtitulo-pack3">
                                            <img src="./assets/img/check.svg" class="img-fluid ico-title" width="13"> Firmado
                                        </h6>
                                    </div>
                                </div>

                                <div class="btn-group me-2" role="group" aria-label="">
                                    <div class="jumbotron-doc pending-doc">
                                        <h6 class="subtitulo-pack3">
                                            <b>Documento aceptación GDPR</b>
                                        </h6>
                                        <h6 class="subtitulo-pack3">
                                            <img src="./assets/img/clock.svg" class="img-fluid ico-title" width="10"> Pendiente de firma
                                        </h6>
                                    </div>
                                </div>

                                <div class="btn-group me-2" role="group" aria-label="">
                                    <div class="jumbotron-doc pending-doc">
                                        <h6 class="subtitulo-pack3">
                                            <b>Documento aceptación GDPR</b>
                                        </h6>
                                        <h6 class="subtitulo-pack3">
                                            <img src="./assets/img/clock.svg" class="img-fluid ico-title" width="10"> Pendiente de firma
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <div class="bb-line"></div>
                        </div>

                        <div class="col-lg-12"><br>

                            <!----- Contratos PDF ------>
                            <!-------------------------->
                            <div class="accordion mb-3" id="accordionExample">
                                <div class="card">
                                    <div class="card-header" id="headingOne">
                                        <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                            data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                            aria-controls="collapseOne">
                                        <div>
                                            <h6 class="subtitulo-pack4">Documento aceptación GDPR</h6>
                                        </div>
                                        <small class="text-muted">
                                            <h6><span class="badge badge-pill badge-success badge-collapse">Firmado</span></h6>
                                        </small>
                                        </div>
                                    </div>

                                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                        <div class="card-body">
                                            Aquí PDF
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingTwo">
                                        <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                            data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                                            aria-controls="collapseTwo">
                                            <div>
                                                <h6 class="subtitulo-pack4">Documento aceptación GDPR</h6>
                                            </div>
                                            <small class="text-muted">
                                                <h6>
                                                    <span class="badge badge-pill badge-pending badge-collapse">Pendiente de firma</span>
                                                </h6>
                                            </small>
                                        </div>
                                    </div>
                                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                        <div class="card-body">
                                            Aquí PDF
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingThree">
                                        <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                            data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                                            aria-controls="collapseThree">
                                            <div>
                                                <h6 class="subtitulo-pack4">Documento aceptación GDPR</h6>
                                            </div>
                                            <small class="text-muted">
                                                <h6>
                                                    <span class="badge badge-pill badge-pending badge-collapse">Pendiente de firma</span>
                                                </h6>
                                            </small>
                                        </div>
                                    </div>
                                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                        data-parent="#accordionExample">
                                        <div class="card-body">
                                            Aquí PDF
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ./ Modal Contratos ---------->
    <!-------------------------------->


    <!------- Modal Pago ------->
    <!-------------------------->

    <div class="modal fade" id="pay" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title white" id="exampleModalLabel">Pago del pedido</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20"></span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-lg-12">

                            <!----- Contratos PDF ------>
                            <!-------------------------->
                            <h6 class="subtitulo-pack4 mb-4">
                                <img src="./assets/img/package.svg" class="img-fluid ico-title" width="20"> Listado de productos
                            </h6>
                            <div class="accordion mb-5" id="accordionExample">
                                <div class="card">
                                    <div class="card-header" id="headingOne">
                                        <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                            data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                            aria-controls="collapseOne">
                                            <div>
                                                <h6 class="subtitulo-pack4">Expediente contratación Fijo y Móvil</h6>
                                            </div>
                                            <small class="text-muted">
                                                <h6>
                                                    <span class="badge badge-pill badge-success badge-collapse">Pagado</span>
                                                </h6>
                                            </small>
                                        </div>
                                    </div>

                                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                        <div class="card-body">
                                            <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                                data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                                aria-controls="collapseOne">
                                                <div>
                                                    <h6 class="subtitulo-pack-contratacion">
                                                        Fibra directa 100 MB + 12GB + Llamadas ilimitadas
                                                    </h6>
                                                </div>
                                                <small class="text-muted">
                                                    <h6>
                                                        <b>40,95 €/mes</b>
                                                    </h6>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingTwo">
                                        <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                            data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                                            aria-controls="collapseTwo">
                                            <div>
                                                <h6 class="subtitulo-pack4">Expediente contratación Terminal 1</h6>
                                            </div>
                                            <small class="text-muted">
                                                <h6>
                                                    <span class="badge badge-pill badge-success badge-collapse">Pagado</span>
                                                </h6>
                                            </small>
                                        </div>
                                    </div>
                                    <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                        <div class="card-body">
                                            <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                                data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                                aria-controls="collapseOne">
                                                <div>
                                                    <h6 class="subtitulo-pack-contratacion">Samsung S21+</h6>
                                                </div>
                                                <small class="text-muted">
                                                    <h6>
                                                        <b>1195,00 €</b>
                                                    </h6>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingThree">
                                        <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                            data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                                            aria-controls="collapseThree">
                                            <div>
                                                <h6 class="subtitulo-pack4">Expediente contratación Línea 2</h6>
                                            </div>
                                            <small class="text-muted">
                                                <h6>
                                                    <span class="badge badge-pill badge-success badge-collapse">Pagado</span>
                                                </h6>
                                            </small>
                                        </div>
                                    </div>
                                    <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                        <div class="card-body">
                                            <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                                data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                                aria-controls="collapseOne">
                                                <div>
                                                    <h6 class="subtitulo-pack-contratacion">4GB + Llamadas ilimitadas</h6>
                                                </div>
                                                <small class="text-muted">
                                                    <h6>
                                                        <b>6,95 €/mes</b>
                                                    </h6>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingFour">
                                        <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                            data-toggle="collapse" data-target="#collapseFour" aria-expanded="false"
                                            aria-controls="collapseFour">
                                            <div>
                                                <h6 class="subtitulo-pack4">Expediente contratación Terminal 2</h6>
                                            </div>
                                            <small class="text-muted">
                                                <h6>
                                                    <span class="badge badge-pill badge-pending badge-collapse">Pendiente de pago</span>
                                                </h6>
                                            </small>
                                        </div>
                                    </div>
                                    <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample">
                                        <div class="card-body">
                                            <div class="d-flex justify-content-between align-items-center contrato-collapse"
                                                data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                                aria-controls="collapseOne">
                                                <div>
                                                    <h6 class="subtitulo-pack-contratacion">Alcatel One Touch easy</h6>
                                                </div>
                                                <small class="text-muted">
                                                    <h6>
                                                        <b>70,00 €/mes</b>
                                                    </h6>
                                                </small>
                                            </div>
                                            <br>
                                            <div align="left" class="mt-1 mb-2">
                                                <a href="#!" class="btn btn-green">Pagar</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ./ Modal Contratos ---------->
    <!-------------------------------->

</ng-container>
